import React, { useState, useEffect } from 'react';
import {
  SimpleView,
  GridView,
  FilterWidget,
  Widget,
  FormSelect,
  FormInput,
  Table,
  Form,
  Row,
  Col,
  Button,
  FormResetButton,
  FormRangePicker,
  CompositeView,
} from '@digital/ui';
import { Icon } from 'antd';
import {
  searchValues,
  RelatorioPrevisoesPgto,
  PrevisaoPagamentoFilter,
  relatorioExportExcel,
} from './@app/../../../api/relatorioPrevisoesPagamento';
import { getAllAnalistaGPCOptions } from '@app/api/usuario';
import { getAllTipoDocumentoCobrancaOptions } from '@app/api/contrato/planilhaQuantidadeContrato';
import { dateFormat } from '@app/helpers/dateTimeFormats';
import { ColumnProps } from 'antd/lib/table';
import { ExcelButton, SearchButton } from '@app/components/FormButtons';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { compareText } from '@app/helpers/comparators';
import { DatePicker } from 'antd';

const RelatorioPrevisoesPagto = () => {
  const [items, setItems] = useState<RelatorioPrevisoesPgto[]>();
  const [getList, setGetList] = useState<boolean>(true);

  useEffect(() => {
    var obj = {} as PrevisaoPagamentoFilter;
    handleFilter(obj);
  }, [getList]);

  const columns: ColumnProps<any>[] = [
    {
      title: 'Nº Contrato',
      dataIndex: 'numeroContrato',
      width: '5%',
      sorter: (a, b) => compareText(a.numeroContrato, b.numeroContrato),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Nº Contrato"
              name="numeroContrato"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => {})}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.numeroContrato &&
        record.numeroContrato
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase()),
    },
    {
      title: 'Cód. Forn.',
      dataIndex: 'numeroFornecedor',
      width: '5%',
      sorter: (a, b) => compareText(a.numeroFornecedor, b.numeroFornecedor),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Cód Fornecedor"
              name="numeroFornecedor"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => {})}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.numeroFornecedor &&
        record.numeroFornecedor
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase()),
    },
    {
      title: 'Fornecedor',
      dataIndex: 'fornecedor',
      width: '10%',
      sorter: (a, b) => compareText(a.fornecedor, b.fornecedor),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Fornecedor"
              name="fornecedor"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => {})}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.fornecedor &&
        record.fornecedor
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase()),
    },
    {
      title: 'Nº BM',
      dataIndex: 'numeroBm',
      width: '5%',
    },
    {
      title: 'PQ',
      dataIndex: 'identificadorPQ',
      width: '5%',
      sorter: (a, b) => compareText(a.numeroContrato, b.numeroContrato),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar PQ"
              name="identificadorPQ"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => {})}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.identificadorPQ &&
        record.identificadorPQ
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase()),
    },
    {
      title: 'Tipo do Documento',
      dataIndex: 'tipoDocumentoCobranca',
      width: '15%',
      sorter: (a, b) => compareText(a.tipoDocumentoCobranca, b.tipoDocumentoCobranca),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Tipo do Documento"
              name="tipoDocumentoCobranca"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => {})}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.tipoDocumentoCobranca &&
        record.tipoDocumentoCobranca
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase()),
    },
    {
      title: 'Nº Documento',
      dataIndex: 'numeroDocumentoCobranca',
      width: '5%',
      sorter: (a, b) => compareText(a.numeroDocumentoCobranca, b.numeroDocumentoCobranca),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Nº Documento"
              name="numeroDocumentoCobranca"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => {})}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.numeroDocumentoCobranca &&
        record.numeroDocumentoCobranca
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase()),
    },
    {
      title: 'Nº Parcela',
      dataIndex: 'numeroParcela',
      width: '5%',
    },
    {
      title: 'Data Emiss. Doc. Cobrança',
      dataIndex: 'dataEmissaoDocumentoCobranca',
      width: '5%',
    },
    {
      title: 'Analista GPC',
      dataIndex: 'analistaGPC',
      width: '10%',
      sorter: (a, b) => compareText(a.analistaGPC, b.analistaGPC),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Analista GPC"
              name="analistaGPC"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => {})}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.analistaGPC &&
        record.analistaGPC
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase()),
    },
    {
      title: 'Área',
      dataIndex: 'area',
      width: '10%',
    },
    {
      title: 'Data Prev. Pagam.',
      dataIndex: 'dataPrevisaoPagamento',
      width: '5%',
    },
    {
      title: 'Valor',
      dataIndex: 'valorParcela',
      width: '5%',
    },
  ];

  const handleFilter = (values: PrevisaoPagamentoFilter) => {
    searchValues(values).then(resp => resp && setItems(resp));
  };

  const handleExcel = async (values: PrevisaoPagamentoFilter) => {
    relatorioExportExcel(values);
  };

  return (
    <CompositeView>
      <SimpleView>
        <GridView onSubmit={handleFilter}>
          <FilterWidget
            active={[]}
            actions={[
              <ExcelButton type="link" key="excelBtn" onClick={handleExcel} />,
              <SearchButton type="primary" key="filterBtn" onClick={handleFilter} />,
            ]}
            title="Filtros">
            <FormRangePicker label="Período" startName="dataInicio" endName="dataFinal" format={dateFormat} span={4} />
            <FormSelect
              showSearch
              optionFilterProp="children"
              filterOption={(input: any, item: any) => {
                return item.props.children.props.id
                  .toString()
                  .toLowerCase()
                  .includes(input.toLowerCase());
              }}
              mode="multiple"
              label="Tipo de documento"
              name="tipoDeDocumentoIds"
              getOptions={getAllTipoDocumentoCobrancaOptions}
              span={4}
            />
            <FormSelect
              showSearch
              optionFilterProp="children"
              filterOption={(input: any, item: any) => {
                return item.props.children.props.id
                  .toString()
                  .toLowerCase()
                  .includes(input.toLowerCase());
              }}
              mode="multiple"
              label="Analista GPC"
              name="analistaGPCIds"
              getOptions={getAllAnalistaGPCOptions}
              span={4}
            />
            <FormInput label="Contrato" name="numeroContrato" span={4} />
            <FormInput label="Código do Fornecedor" name="codigoFornecedor" span={4} />
            <FormInput label="Número do Documento" name="numeroDocumento" span={4} />
          </FilterWidget>
          <Widget title="Relatório de Previsões de Pagamento">
            <PerfectScrollbar>
              <Table columns={columns} dataSource={items || []} pagination={{pageSize: 100}} />
            </PerfectScrollbar>
          </Widget>
        </GridView>
      </SimpleView>
    </CompositeView>
  );
};

export default RelatorioPrevisoesPagto;
